import { Outlet } from "react-router-dom";

/**
 * Knowledge Base shell. The section nav (Browse / Categories / Saved / Recently
 * viewed) used to live in a left sub-rail here; as of issue #7 it expands inline
 * under "Knowledge Base" in the main sidebar (see config/nav.ts), so this is now
 * just the parent route element that renders the active section.
 */
export function KbLayout() {
  return <Outlet />;
}

export default KbLayout;
